module.exports = __webpack_public_path__ + "img/new-close.aeb45094.svg";